import type { CartExperimentConfig } from './resolver';
import type { CartExperimentValue } from './types';

/** 黑五期间浮窗固定第 1 组并跳过实验请求；结束后改回 null 恢复原分流，不覆盖完整页分组。 */
export const CART_POPOVER_EXPERIMENT_OVERRIDE: CartExperimentValue | null = 1;

/** 后端已确认的四组参数；不得复用旧自动优惠实验。 */
export const CART_EXPERIMENT_PARAM_NAME = 'is_Cart_Version';

/** 前端契约修订，用于解析缓存隔离；不是实验平台返回的版本号。 */
export const CART_EXPERIMENT_CONFIG = {
  enabled: true,
  paramName: CART_EXPERIMENT_PARAM_NAME,
  revision: 'cart-version-v1',
} as const satisfies CartExperimentConfig;
